import {ICrudOptions} from './crud';

//#region INTERFACE IUserAccessFeatureLocalStorageSettings
export interface IUserAccessFeatureLocalStorageSettings {
  storageManager: ICrudOptions;
}

//#endregion

//#region CONST _DEFAULT_USER_ACCESS_LOCAL_STORAGE_SETTINGS
export const _DEFAULT_USER_ACCESS_LOCAL_STORAGE_SETTINGS: Readonly<ICrudOptions & Object> = {
  canEdit: true,
  canSubmit: true,
  canView: true,
  isEdited: false,
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_FEATURE_LOCAL_STORAGE_SETTINGS
export const _DEFAULT_USER_ACCESS_FEATURE_LOCAL_STORAGE_SETTINGS: Readonly<IUserAccessFeatureLocalStorageSettings & Object> = {
  storageManager: _DEFAULT_USER_ACCESS_LOCAL_STORAGE_SETTINGS,
};
//#endregion
